import HttpClienteToken from '../../services/HttpClientToken';

import { DistritoJudicialProps } from '../../interfaces/catalogos/DistritoJudicialInterface';

export const DistritoJudicial = () => {

    return new Promise<DistritoJudicialProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/DistritoJudicial/', token)
            .then( ({ data } : { data : DistritoJudicialProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerDistritoJudicial = () => {

    return new Promise<DistritoJudicialProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.get('/Api/DistritoJudicial/ObtenerDistritoJudicial', token)
            .then( ({ data } : { data : DistritoJudicialProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarDistritoJudicial = ( params: DistritoJudicialProps ) => {

    return new Promise<DistritoJudicialProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/DistritoJudicial/Actualizar', params, token)
            .then( ({ data } : { data : DistritoJudicialProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idDistritoJudicial: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarDistritoJudicial = ( params: DistritoJudicialProps ) => {

    return new Promise<DistritoJudicialProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClienteToken.post('/Api/DistritoJudicial/Agregar', params, token)
            .then( ({ data } : { data : DistritoJudicialProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idDistritoJudicial: 0,                   
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}